import React from 'react';
import { motion } from 'framer-motion';
import variants from 'motion-variants';
import PageTitle from 'components/PageTitle';

const Page = ({
  children = [] as any,
  title = '',
  titleRight = <></>,
  icon = null,
  cardWrapperClassName = '',
}) => {
  return (
    <div
      className="relative flex-grow p-8 overflow-x-auto overflow-y-auto"
      // animate="in"
      // exit="out"
      // transition={variants.fadeTransition}
      // variants={variants.fadeChildren} // staggered transition of child elements
    >
      <header className="flex items-center justify-between max-w-screen-xl">
        <div className="flex items-center">
          {icon}
          {title && <PageTitle>{title}</PageTitle>}
        </div>
        <div>{titleRight}</div>
      </header>
      <div className="max-w-screen-xl card-wrapper">
        {(Array.isArray(children) ? children : [children]).map((child, i) => {
          if (!child) return null;
          return (
            <div
              // variants={variants.fade}
              // initial={{ opacity: 0 }}
              key={i}
              className={`card-motion ${cardWrapperClassName}`}
            >
              {child}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Page;
